import { axiosRequest } from '@/util/axios-request';
var method = 'get';
// const resignlist = '/web/approval/resignlist'
var lists = '/web/staff_resign/lists';
var addResignUrl = '/web/staff_resign/addResign';
var editResignUrl = '/web/staff_resign/editResign';
var cancelResignUrl = '/web/staff_resign/cancelResign';
var exportUrl = '/web/staff_resign/export';
var detail = '/web/approval/detail';
var deleteStaff = '/web/staff/remove';
var inviteStaffData = '/web/staff/inviteStaffData';
var inviteStaffRegister = '/web/staff/inviteStaffRegister';
var staffresign = '/web/staff_resign/init';
var StaffAuditResign = '/web/staff_resign/getStaffAuditResign';
var IsWaitAudit = '/web/approval/isWaitAudit';

// 离职管理列表
export var getResignlist = function getResignlist(params) {
  return axiosRequest({
    url: lists,
    method: method,
    params: params
  });
};
// 办理离职
export var addResign = function addResign(data) {
  return axiosRequest({
    url: addResignUrl,
    data: data
  });
};
// 编辑离职信息
export var editResign = function editResign(data) {
  return axiosRequest({
    url: editResignUrl,
    data: data
  });
};
// 恢复在职
export var cancelResign = function cancelResign(data) {
  return axiosRequest({
    url: cancelResignUrl,
    data: data
  });
};
// 离职管理列表导出
export var exportExcel = function exportExcel(params) {
  return axiosRequest({
    url: exportUrl,
    method: method,
    params: params
  });
};
// 详情接口 /web/approval/detail
export var getDetail = function getDetail(params) {
  return axiosRequest({
    url: detail,
    params: params
  });
};
// 员工删除
export var deleteStaffFun = function deleteStaffFun(params) {
  return axiosRequest({
    url: deleteStaff,
    params: params
  });
};

// 邀请员工时获取当前激活和未激活员工数量
export var getInviteStaffData = function getInviteStaffData(data) {
  return axiosRequest({
    url: inviteStaffData,
    data: data
  });
};

// 发送邀请员工短信
export var inviteStaffRegisterFn = function inviteStaffRegisterFn(data) {
  return axiosRequest({
    url: inviteStaffRegister,
    data: data
  });
};

// 离职管理枚举项
export var getInit = function getInit(data) {
  return axiosRequest({
    url: staffresign,
    data: data
  });
};

// 查询是否有进行中的离职审批流
export var getStaffAuditResign = function getStaffAuditResign(data) {
  return axiosRequest({
    url: StaffAuditResign,
    data: data
  });
};

// 判断当前员工是否有独自待审批节点任务
export var isWaitAudit = function isWaitAudit(data) {
  return axiosRequest({
    url: IsWaitAudit,
    data: data
  });
};